import React from 'react';
import Usuarios from "./usuarios/Usuarios";
import ConsumidorFinal from "./consumidorFinal/ConsumidorFinal";
import Dashboard from "./dashboard/Dashboard";
import PendentesProcessamento from "./pendentesProcessamento/PendentesProcessamento";
import Administradores from "./administradores/Administradores";
import DestaquesHome from "./destaquesHome/DestaquesHome";
import Catalogos from "./catalogos/Catalogos";
import Configuracoes from "./configuracoes/Configuracoes";
import Itinerarios from "./itinerarios/Itinerarios";
import Categorias from './categorias/Categorias';
import Produtos from './produtos/Produtos';
import Campanhas from './campanhas/Campanhas';
import Pedidos from './pedidos/Pedidos';
import Recebimentos from './recebimentos/Recebimentos';
import Faturamentos from './faturamentos/Faturamentos';
/** 
 * 
<li className="item">
    <div onClick={() => { handleModule('janelas', 'Janela') }}><span className="material-icons">date_range</span> Janela</div>
</li>
<li className="item">
    <div onClick={() => { handleModule('recebimentos', 'Recebimentos') }}><span className="material-icons">paid</span> Recebimentos</div>
</li>
<li className="item">
    <div onClick={() => { handleModule('devolucoes', 'Devoluções') }}><span className="material-icons">swap_horizontal_circle</span> Devoluções</div>
</li> */
const Rotas = [
    { label: "Home", rota: "home", icon: 'home', subitems: [], component: <Dashboard /> },
    {
        label: "Gerenciar Usuários", rota: "", icon: "account_circle", subitems: [
            { label: "Revendedoras", rota: "usuarios", component: <Usuarios /> },
            { label: "Consumidor Final", rota: "consumidorFinal", component: <ConsumidorFinal /> },
            { label: "Pendentes Processamento", rota: "pendentesProcessamento", component: <PendentesProcessamento /> },
            { label: "Administradores", rota: "administradores", component: <Administradores /> }
        ]
    },
    {   
        label: "Pedidos", rota: "", icon: "shopping_bag", subitems: [
            { label: "Compra", rota: "pedidos-compra", component: <Pedidos /> },
            { label: "Venda", rota: "pedidos-venda", component: <Pedidos /> }
        ]    
    },
    {
        label: "Gerenciar Site", rota: "", icon: "apps", subitems: [
            { label: "Carrossel Home", rota: "carrossel-home", component: <DestaquesHome /> },
            { label: "Destaques Home", rota: "destaques-home", component: <DestaquesHome /> },
            { label: "Catálogos", rota: "catalogos", component: <Catalogos /> },
            { label: "Configurações", rota: "configuracoes", component: <Configuracoes /> },
            { label: "Newsletter", rota: "newsletter", component: "..." }
        ]
    },
    { 
        label: "Estoque", rota: "", icon: "inventory", subitems: [
            { label: "Categorias", rota: "categorias", component: <Categorias /> },
            { label: "Produtos", rota: "produtos", component: <Produtos /> },
        ] 
    },
    { label: "Itinerários", rota: "itinerarios", icon: "pin_drop", subitems: [], component: <Itinerarios /> },
    { label: "Campanhas", rota: "campanhas", icon: "date_range", subitems: [], component: <Campanhas /> },
    { label: "Rec / Fat", rota: "", icon: "paid", subitems: [
        { label: "Recebimentos", rota: "recebimentos", component: <Recebimentos /> },
        { label: "Faturamentos", rota: "faturamentos", component: <Faturamentos /> }, 
    ] },
    { label: "Devoluções", rota: "devolucoes", icon: "swap_horizontal_circle", subitems: [], component: "..." },
];

export default Rotas;